import type { IconNode } from '../types';

/**
 * @name whisk-fork-knife
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNiAyQzMuOCAyIDIgMy44IDIgNnM0IDggNCA4IDQtNS44IDQtOC0xLjgtNC00LTR6IiAvPgogIDxwYXRoIGQ9Ik02IDIyVjIiIC8+CiAgPHBhdGggZD0iTTE4IDIydi00YTIgMiAwIDAgMC0yLTJoLTRhMiAyIDAgMCAwLTIgMnY0IiAvPgogIDxwYXRoIGQ9Ik0xNCAyMlYyIiAvPgogIDxwYXRoIGQ9Ik0yMiAxM2gtMmEyIDIgMCAwIDEtMi0yVjZhNCA0IDAgMCAxIDQtNHYyMCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/whisk-fork-knife
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const whiskForkKnife: IconNode = [
  ['path', { d: 'M6 2C3.8 2 2 3.8 2 6s4 8 4 8 4-5.8 4-8-1.8-4-4-4z', key: 'wirpud' }],
  ['path', { d: 'M6 22V2', key: 'mbtad' }],
  ['path', { d: 'M18 22v-4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v4', key: '10tav2' }],
  ['path', { d: 'M14 22V2', key: 'wiogty' }],
  ['path', { d: 'M22 13h-2a2 2 0 0 1-2-2V6a4 4 0 0 1 4-4v20', key: 'obj70b' }],
];

export default whiskForkKnife;
